import React, { useState, useEffect } from "react";
import {
  Dialog,
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField,
  ThemeProvider,
  Typography,
  createTheme,
} from "@mui/material";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import "../modals/modal.css";
import CustomButton from "../../reusableComponents/CustomButton";
import "../reports/reports.css"

const theme = createTheme({
  components: {
    MuiRadio: {
      styleOverrides: {
        root: {
          color: "rgba(36, 183, 170, 1)",
          height: "16px",
          width: "16px",
          marginRight: "8px",
          marginLeft: "10px",
          "&.Mui-checked": {
            color: "rgba(36, 183, 170, 1)",
            height: "16px",
            width: "16px",
            marginRight: "8px",
          },
        },
      },
    },
  },
});
let advCount = 0
export default function DateModal({
  openModal = false,
  sendDataFromDateModal = () => { },
  onClose = () => { },
  presentData = []
}) {
  const [selectedValue, setSelectedValue] = useState("");
  const today = new Date();

  const [selectedDate, setSelectedDate] = useState(null);
  const [initialdate, setInitialDate] = useState(null);
  const [singleDateError, setSingleDateError] = useState(false);
  const [startDateRangeError, setStartDateRangeError] = useState(false);
  const [endDateRangeError, setEndDateRangeError] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [initialStartDate, setInitialStart] = useState(null);
  const [initialEndDate, setInitialEnd] = useState(null);
  const [startDateWithoutField, setStartDateWithoutFiled] = useState(null);
  const [endDateWithoutField, setEndDateWithoutField] = useState(null);
  const [startDateForSingleDate, setStartDateForSingleDate] = useState(null);
  const [endDateForSingleDate, setEndDateForSingleDate] = useState(null);
  const [startDateRange, setStartDateRange] = useState(null);
  const [endDateRange, setEndDateRange] = useState(null);
  const [dateRangeValidation, setDateRangeValidation] = useState(false)
  const handleDateRangeError = (e, type) => {
    if (type == 'start') {
      if (e == 'maxDate' || e == 'minDate') {
        setDateRangeValidation(true)

      } else {
        setDateRangeValidation(false)
      }
    } else if (type == 'end') {
      if (e == 'maxDate' || e == 'minDate') {
        setDateRangeValidation(true)
      } else {
        setDateRangeValidation(false)
      }
    } else {

    }

  }
  const handleStartDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setStartDate(date);
      setStartDateRangeError(false);

    }
    else {
      setStartDateRangeError(true);
    }
  };

  const handleDateChange = (date) => {
    if (date instanceof Date && !isNaN(date)) {
      setSelectedDate(date);
      setSingleDateError(false);
    }
    else {
      setSingleDateError(true);
    }
  };

  const handleEndDateChange = (date) => {
    if (date instanceof Date && !isNaN(date) && date > startDate) {
      setEndDate(date);
      setEndDateRangeError(false);

    }
    else {
      setEndDateRangeError(true);
    }
  };

  const handleRadioChange = (e) => {
    setSelectedValue(e.target.value);
  };


  const handleSelectedValueChange = (value) => {
    if (value === "last15minutes") {
      const currentTime = new Date();
      const fifteenMinutesAgo = new Date(currentTime.getTime() - 15 * 60 * 1000);
      const endOfFifteenMinutesAgo = new Date(currentTime.getTime() - 1);

      setStartDateWithoutFiled(fifteenMinutesAgo);
      setEndDateWithoutField(endOfFifteenMinutesAgo);
    } else if (value === "Last24hours") {
      const endOfToday = new Date();
      const startOfLast24Hours = new Date(endOfToday);
      startOfLast24Hours.setUTCHours(startOfLast24Hours.getUTCHours() - 24);

      setStartDateWithoutFiled(startOfLast24Hours);
      setEndDateWithoutField(endOfToday);
    } else if (value === "last7Days") {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 7);
      startDate.setUTCHours(0, 0, 0, 0);

      const todayEnd = new Date();
      todayEnd.setDate(todayEnd.getDate() - 1);
      todayEnd.setUTCHours(23, 59, 59, 999);
      setStartDateWithoutFiled(startDate);
      setEndDateWithoutField(todayEnd);
    } else if (value === "lastMonth") {
      const startDate = new Date();
      startDate.setDate(startDate.getDate() - 30);
      startDate.setUTCHours(0, 0, 0, 0);
      const todayEnd = new Date();
      todayEnd.setDate(todayEnd.getDate() - 1);
      todayEnd.setUTCHours(23, 59, 59, 999);
      setStartDateWithoutFiled(startDate);
      setEndDateWithoutField(todayEnd);
    } else if (value === "singleDate") {
      if (selectedDate) {
        const startDate = new Date(selectedDate);
        startDate.setHours(0, 0, 0, 0);

        const todayEnd = new Date(selectedDate);
        todayEnd.setHours(23, 59, 59, 999);

        setStartDateForSingleDate(startDate);
        setEndDateForSingleDate(todayEnd);
      }
    } else if (value === "dateRange") {
      setDateRangeValidation(true)
      if (startDate && endDate) {
        if (advCount == 0) {
          setDateRangeValidation(false)
        }
        advCount = 9
        const startDateRange = new Date(startDate);
        startDateRange.setHours(0, 0, 0, 0);

        const todayEnd = new Date(endDate);
        todayEnd.setHours(23, 59, 59, 999);
        setStartDateRange(startDateRange);
        setEndDateRange(todayEnd);
      }
    }
  };

  useEffect(() => {
    handleSelectedValueChange(selectedValue);
  }, [selectedValue, selectedDate, startDate, endDate]);


  useEffect(() => {
    setSingleDateError(false);
    setStartDateRangeError(false);
    setEndDateRangeError(false);
  }, [selectedValue]);

  useEffect(() => {
    setSelectedDate(null);
    setStartDate(null);
    setEndDate(null);
    advCount = 0
  }, [selectedValue]);

  useEffect(() => {
    if (presentData) {
      setSelectedValue(presentData?.selectedValue)
      setFinalStartDate(presentData?.finalStartDate)
      setFinalEndDate(presentData?.finalEndDate)

      if (presentData?.selectedValue === "singleDate") {
        const endDate = new Date(presentData?.finalEndDate);
        setInitialDate(endDate);
      } else if (presentData?.selectedValue === "dateRange") {
        const startDate = new Date(presentData?.finalStartDate);
        setInitialStart(startDate);
        const endDate = new Date(presentData?.finalEndDate);
        setInitialEnd(endDate);
      }
    }
  }, [presentData]);

  const [finalStartDate, setFinalStartDate] = useState("");
  const [finalEndDate, setFinalEndDate] = useState("");

  useEffect(() => {
    if (selectedValue === "last15minutes" ||
      selectedValue === "Last24hours" ||
      selectedValue === "last7Days" ||
      selectedValue === "lastMonth") {
      setFinalStartDate(utcStartDateWithoutFiled);
      setFinalEndDate(utcEndDateWithoutFiled);
    }
    else if (selectedValue === "singleDate") {
      setFinalStartDate(utcStartDateForSingleDate);
      setFinalEndDate(utcEndDateForSingleDate);
    }
    else if (selectedValue === "dateRange") {
      setFinalStartDate(utcStartDate);
      setFinalEndDate(utcEndDate);
    }
  }, [startDateWithoutField, endDateWithoutField, startDateForSingleDate, endDateForSingleDate, startDateRange, endDateRange]);

  const formatDateToUTC = (date) => {
    if (date) {
      let dateIST = date;
      let dateUTC = dateIST.toISOString();
      return dateUTC;
    }
    return null;
  };

  const utcStartDate = formatDateToUTC(startDateRange);
  const utcEndDate = formatDateToUTC(endDateRange);
  const utcStartDateWithoutFiled = formatDateToUTC(startDateWithoutField);
  const utcEndDateWithoutFiled = formatDateToUTC(endDateWithoutField);
  const utcStartDateForSingleDate = formatDateToUTC(startDateForSingleDate);
  const utcEndDateForSingleDate = formatDateToUTC(endDateForSingleDate);

  const submitDateModal = () => {
    const data = {
      selectedValue,
      finalStartDate,
      finalEndDate
    };
    sendDataFromDateModal(data);
    onClose();
  };

  const handleCloseModal = () => {
    onClose();
  };

  const handleClearAllData = () => {
    setFinalStartDate("");
    setFinalEndDate("");
    setSelectedValue("");
    setInitialStart("");
    setInitialEnd("");
    setInitialDate("");
  };

  const isSingleDateSelected = selectedValue === "singleDate";
  const isDateRangeSelected = selectedValue === "dateRange";
  const isApplyButtonDisabled = (isSingleDateSelected && !selectedDate) ||
    (isDateRangeSelected && dateRangeValidation);

  const dates = [
    { key: "Last 15 minutes", value: "last15Minutes" },
    { key: "Last 24 hours", value: "last24Hours" },
    { key: "Last week", value: "lastWeek" },
    { key: "Single date", value: "singleDate" },
    { key: "Date range", value: "dateRange" },
  ];

  const handleKeyDown = (event) => {
    if (event.key === "Escape") {
      handleCloseModal();
    }
  };
  return (
    <>
      <Dialog
        className="orderManagementModal"
        open={openModal}
        onKeyDown={handleKeyDown}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            marginBottom: "6px",
            padding: "24px 24px 0px 24px",
          }}
        >
          <Typography className="SemiboldTwenty font-black-highest">
            Date
          </Typography>
          <img
            src="/assets/ic_twotone-close.svg"
            alt="cross"
            onClick={() => handleCloseModal()}
            style={{ cursor: "pointer" }}
          />
        </div>
        <Typography
          className="labelRegular font-black-high"
          style={{ padding: "0px 24px" }}
        >
          Select the date for listing the
        </Typography>
        <div
          className="displayDirectionRow"
          style={{
            display: "flex",
            marginTop: "20px",
            height: "250px",
            padding: "0px 24px",
          }}
        >
          <ThemeProvider theme={theme}>
            <div>
              <div className="radioBtn">
                <FormControlLabel
                  className={`radioLabels ${selectedValue === "last15minutes" && "selectedRadioColor"
                    }`}
                  value="last15minutes"
                  control={<Radio color="default" />}
                  label="Last 15 minutes"
                  checked={selectedValue === "last15minutes"}
                  onChange={(e) => handleRadioChange(e)}
                />
              </div>
              <div className="radioBtn">
                <FormControlLabel
                  className={`radioLabels ${selectedValue === "Last24hours" && "selectedRadioColor"
                    }`}
                  value="Last24hours"
                  control={<Radio color="default" />}
                  label="Last 24 hours"
                  checked={selectedValue === "Last24hours"}
                  onChange={(e) => handleRadioChange(e)}
                />
              </div>

              <div className="radioBtn">
                <FormControlLabel
                  className={`radioLabels ${selectedValue === "last7Days" && "selectedRadioColor"
                    }`}
                  value="last7Days"
                  control={
                    <Radio
                      style={{
                        fontFamily: "Poppins",
                        fontWeight: 500,
                        fontSize: "14px",
                      }}
                    />
                  }
                  label="Last 7 days"
                  checked={selectedValue === "last7Days"}
                  onChange={(e) => handleRadioChange(e)}
                />
              </div>

              <div className="radioBtn">
                <FormControlLabel
                  className={`radioLabels ${selectedValue === "lastMonth" && "selectedRadioColor"
                    }`}
                  value="lastMonth"
                  control={<Radio />}
                  label="Last 30 days"
                  checked={selectedValue === "lastMonth"}
                  onChange={(e) => handleRadioChange(e)}
                />
              </div>
              <div className="radioBtn">
                <FormControlLabel
                  className={`radioLabels ${selectedValue === "singleDate" && "selectedRadioColor"
                    }`}
                  value="singleDate"
                  control={<Radio color="default" />}
                  label="Single Date"
                  checked={selectedValue === "singleDate"}
                  onChange={(e) => handleRadioChange(e)}
                />
              </div>
              <div className="radioBtn">
                <FormControlLabel
                  className={`radioLabels ${selectedValue === "dateRange" && "selectedRadioColor"
                    }`}
                  value="dateRange"
                  control={<Radio color="default" />}
                  label="Date Range"
                  checked={selectedValue === "dateRange"}
                  onChange={(e) => handleRadioChange(e)}
                />
              </div>
            </div>
          </ThemeProvider>
          <div className="dateRange">
            {selectedValue === "singleDate" ? (
              <>
                <div style={{ display: "flex" }}>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DatePicker
                      format="dd/MM/yyyy"
                      value={initialdate || selectedDate}
                      onChange={handleDateChange}
                      maxDate={today}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          style={{ borderColor: singleDateError ? "red" : "blue" }}
                        />
                      )}
                    />
                  </LocalizationProvider>
                </div>
                <div>
                  {singleDateError && (
                    <div className="errorStyling">
                      <img src="/assets/errorOutline.svg" className="errorImg" />
                      <Typography className="errorMessage">
                        Please select date
                      </Typography>
                    </div>
                  )}
                </div>
              </>
            ) : null}
            {selectedValue === "dateRange" ? (
              <>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                  <div
                    style={{ display: "flex" }}
                  >
                    <DatePicker
                      format="dd/MM/yyyy"
                      maxDate={today}
                      onError={(e) => handleDateRangeError(e, 'start')}
                      value={initialStartDate || startDate}
                      onChange={handleStartDateChange}
                      renderInput={(params) => <TextField {...params} style={{ borderColor: startDateRangeError ? "red" : "blue" }} />}
                    />
                    <DatePicker
                      format="dd/MM/yyyy"
                      value={initialEndDate || endDate}
                      minDate={startDate}
                      maxDate={today}
                      onError={(e) => handleDateRangeError(e, 'end')}
                      disableDates={(date) => {
                        return date <= startDate;
                      }}
                      onChange={handleEndDateChange}
                      style={{ marginRight: "8px" }}
                      renderInput={(params) => <TextField {...params} style={{ borderColor: endDateRangeError ? "red" : "blue" }} />}
                    />
                  </div>
                </LocalizationProvider>
                {/*  <div className="displayDirectionRow">
                  {startDateRangeError ? (
                    <div
                      className="errorStyling"
                      style={{ marginLeft: "20px", width: "200px" }}
                    >
                      <img src="/assets/errorOutline.svg" className="errorImg" />
                      <Typography className="errorMessage">
                        Please select start date
                      </Typography>
                    </div>
                  ) : (
                    <div style={{ width: "200px", marginRight: "8px" }} />
                  )}
                  {endDateRangeError && (
                    <div
                      className="errorStyling"
                      style={{ marginLeft: "0px", width: "200px" }}
                    >
                      <img src="/assets/errorOutline.svg" className="errorImg" />
                      <Typography className="errorMessage">
                        Please select end date
                      </Typography>
                    </div>
                  )}
                </div> */}
              </>
            ) : null}
          </div>
        </div>
        <div
          style={{
            paddingBottom: "24px",
            paddingTop: "24px",
            display: "flex",
            justifyContent: "end",
            paddingRight: "24px",
            boxShadow: "0px -2px 8px 0px rgba(39, 39, 39, 0.15)",
          }}
        >
          <CustomButton
            variant={"outlined"}
            size={"sm"}
            type={"secondary"}
            text={"Clear All"}
            onClick={() => handleClearAllData()}
          />
          <div style={{ marginLeft: "8px" }}>
            <CustomButton
              variant={"contained"}
              size={"sm"}
              type={"secondary"}
              text={"Apply"}
              disabled={isApplyButtonDisabled}
              onClick={submitDateModal}
            />
          </div>

        </div>

      </Dialog>
    </>
  );
}
